/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import MaskedInput from "react-text-mask";
import InputField from "~components/Form/components/InputField";
import ContainerForm from "~components/Form/components/ContainerForm";
import mask from "~services/utils/mask";
import { DeleteEdit, IconSuccess, WarningIcon } from "~misc/icons";
import { useSalvarRecebedor, useSalvarEmissor } from "~pages/Wallet/hooks/useWallet";
import Select from "~components/Form/components/Select";
import useReceiver from "../hooks/useReceiver";
import {db} from "~/db/db";

import {
  setEmptyToSelectsOptions,
  defaultEmptyMessages,
  recebimentoDefaultOptions,
} from "~services/utils/defaultOptions";

import AddressForm from "~components/Form/components/AddressForm";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import prepareForOptions from "~services/utils/prepareForOptions";
import useGrupoSegmento from "~/fetchs/useGrupoSegmento";
import useSegmento from "~/fetchs/useSegmento";
import useCliente from "~/fetchs/useCliente";
import ExcluirModal from "~pages/PricesTable/components/Modal/ExcluirModal";
import useAll from "~/fetchs/useAll";
import { Box, useToast } from "@chakra-ui/react";
import { ChevronRightIcon , CheckIcon} from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";
import useCargo from "~/fetchs/useCargo";
import useUsuario from "~fetchs/useUsuario";
import Tooltip from "~components/Geral/Tooltip";
import useSelect from "~components/Form/hooks/useSelect";
import Info from "~components/Form/components/Info";
import useParametros from "~fetchs/useParametros";
import useModalAction from "~components/Modal/hooks/useModalAction";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import useEquipeVenda from "~fetchs/useEquipeVenda";
import useEscritorioVenda from "~fetchs/useEscritorioVenda";
import ModalContatoSalvos from "~components/Modal/ModalContatoSalvo";
import ModalContato from "~components/Modal/ModalContato";
import ModalDeclaracao from "~components/Modal/ModalDeclaracao";
import Modal from "~components/Modal/index";
import { permiteNomeObra, normalizeNomeObra } from "~services/utils/nomeObra";

import RegistrationJourneyModals from "../../components/RegistrationJourneyModals";

const ReceiverFormEdit = (opt = {}) => {
  const newContato = {
    nome: "",
    sobrenome: "",
    cargoId: null,
    email: "",
    telefone: "",
    celular: "",
    fonte: "",
  };

  const { usuario } = useUsuario();
  const [formModalValues, setFormModalValues] = useState({});
  const [formModalValuesCreate, setFormModalValuesCreate] = useState({});

  const [segmentoDistribuidorDisponivel, setSegmentoDistribuidorDisponivel] = useState(true);
  const [exibirTodosContatos, setExibirTodosContatos] = useState(false);

  const expandirTodosContatos = useCallback(() => setExibirTodosContatos(true), []);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [abrirModalDeclaracao, setAbrirModalDeclaracao] = useState(false);
  const [modalEnviada, setModalEnviada] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const formikRef = useRef();
  const ArrayContatoRef = useRef();
  const navigate = useNavigate();
  const { cliente, recebedorEmissor } = opt;
  const acessoJornadaFunil = ["IMO", "INFRA"].includes(cliente?.trilha?.nome?.toUpperCase()) && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');

  const { validationSchema, initialValues, setinitialValues } = useReceiver(opt.id, !recebedorEmissor);

  const [grupoSegmentosInitialized, setGrupoSegmentosInitialized] = useState(0);

  const { recebimentoSelect, onChangeRecebimento } = useAll(formikRef);
  const recebimentoOptions = recebimentoDefaultOptions;

  const { isModalOpen, closeModal, modalStatus, setMessageStatus, messageStatus, openModal, setSubmessageStatus, submessageStatus,} = useModalResponse();
  const {isModalOpenAction: isModalContatoSalvar, closeModalAction: closeModalContatoSalvar, openModalAction: openModalContatoSalvar,} = useModalAction();

  //States
  const [formValues, setFormValues] = useState({});
  const [selectedContact, setSelectedContact] = useState({});
  const editFormSelect = true

  //IndexsDB
  const { optionsTrilha, trilha, trilhas, onChangeTrilha, trilhaSelect, SetSelectTrilha, trilhasObjId, trilhasObjCodigo, trilhasObjNome } = useTrilha(formikRef);
  const { optionsEquipe, equipe, optionsEquipeedit, SetSelectEquipe,clearEquipe, onChangeEquipe, equipeSelect } = useEquipeVenda(formikRef, editFormSelect, cliente);
  const { optionsEscritorio, optionsEscritorioedit, escritorio, SetSelectEscritorio, clearEscritorio, onChangeEscritorio, escritorioSelect } = useEscritorioVenda(formikRef,  equipeSelect, editFormSelect, cliente);
  const {
    gruposCentralizadores,
    optionGruposCentralizadores,
    grupoCentralizadorSelect,
    onChangeGrupoCentralizador,
    SetSelectGrupoCentralizador,
  } = useGrupoCentralizador(formikRef);

  const { optionsGrupoSegmento, grupoSegmento, grupoSegmentoSelect, grupoSegmentoObjeto, onChangeGrupoSegmento, SetSelectGrupoSegmento, } = useGrupoSegmento({ formikRef, trilha, permitir: grupoSegmentosInitialized });
  const { optionsSegmento, segmentoSelect, onChangeSegmento, SetSelectSegmento } = useSegmento( grupoSegmento, formikRef);
  const { toObjectSlug } = useParametros();
  const grupoCentralizadorConstrutoraSelect = useSelect("grupoCentralizadorConstrutoraId");
  const grupoCentralizadorConstrutoraParam = toObjectSlug["grupos-centralizador-construtoras"];
  const imoLinkCadastroGrupoRaw = toObjectSlug["imo-link-cadastro-grupo"]?.valorCorrigido;
  const imoLinkCadastroGrupo = imoLinkCadastroGrupoRaw && imoLinkCadastroGrupoRaw?.toLowerCase() !== 'false'
    ? imoLinkCadastroGrupoRaw
    : null;
  const grupoCentralizadorConstrutoraOptions = useMemo(() => {
    const filtrados = (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha);
    return prepareForOptions(filtrados, ["codigo", "nome"], "id");
  }, [gruposCentralizadores, trilha]);
  const filteredGrupoCentralizador = useMemo(() => (gruposCentralizadores || []).filter((g) => g.trilhaId === trilha), [gruposCentralizadores, trilha]);
  const [grupoOptionsState, setGrupoOptionsState] = useState([]);
  const [grupoOptionsLoaded, setGrupoOptionsLoaded] = useState(false);
  const [selectedGrupoOption, setSelectedGrupoOption] = useState(null);
  const [grupoLoading, setGrupoLoading] = useState(true);

  const loadGrupoOptions = useCallback(() => {
    if ( grupoOptionsLoaded ) return;
    setGrupoLoading(true);
    // allow spinner to render before heavy mapping
    setTimeout(() => {
      const opts = prepareForOptions(filteredGrupoCentralizador, ["codigo", "nome"], "id");
      setGrupoOptionsState(opts);
      setGrupoOptionsLoaded(true);
      setGrupoLoading(false);
    }, 50);
  }, [filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading]);
  useEffect(() => {
    const currentId = formikRef.current?.values?.grupoCentralizadorConstrutoraId;
    if (currentId) {
      const opt = grupoCentralizadorConstrutoraOptions.find((o) => String(o.value) === String(currentId));
      if (opt) setSelectedGrupoOption(opt);
    }
  }, [grupoCentralizadorConstrutoraOptions]);

  const trilhasPermitidas = useMemo(() => {
    const raw = grupoCentralizadorConstrutoraParam?.valor || "";
    const codigos = raw
      .split(",")
      .map((codigo) => codigo.trim().toUpperCase())
      .filter(Boolean);
    return codigos
      .map((codigo) => trilhasObjCodigo?.[codigo]?.id || trilhasObjNome?.[codigo]?.id)
      .filter(Boolean);
  }, [grupoCentralizadorConstrutoraParam?.valor, trilhasObjCodigo, trilhasObjNome]);
  const isTrilhaPermitida = trilhasPermitidas.includes(trilha);
  const imoTrilhaId =
    trilhasObjNome?.IMO?.id || trilhasObjCodigo?.IMO?.id || trilhasObjCodigo?.["410"]?.id;
  const isTrilhaIMO = imoTrilhaId ? String(trilha) === String(imoTrilhaId) : false;
  const exibirNomeObra = permiteNomeObra(trilhasObjId?.[`key-${trilha}`]);

  const { optionsCargo, cargoSelect, handleCargoChange, SetSelectCargo } = useCargo(formikRef);
  const onChangeGrupoCentralizadorConstrutora = (e) => {
    const value = e?.value ?? null;
    grupoCentralizadorConstrutoraSelect.upDateValue(value || "");
    grupoCentralizadorConstrutoraSelect.upDateDefaultValue(e || "");
    formikRef.current?.setFieldValue("grupoCentralizadorConstrutoraId", value);
    setTimeout(() => formikRef.current?.setFieldTouched("grupoCentralizadorConstrutoraId", true));
  };

  useEffect(() => {
    if (!grupoOptionsLoaded && isTrilhaPermitida && filteredGrupoCentralizador && filteredGrupoCentralizador.length > 0) {
      loadGrupoOptions();
    }
  }, [isTrilhaPermitida, filteredGrupoCentralizador, loadGrupoOptions]);

  //FunctionsIndexDB
  async function fetchListagemRecebedores(data) {
    if (data) {
      var filtered = data;
      filtered.tipoN = filtered.tipo !== undefined ? filtered.tipo : null;
      filtered.tipo = filtered.tipo !== undefined ? (filtered.tipo == 1 ? "Pessoal Física" : "Pessoa Jurídica") : "";
      if (filtered.contatos && filtered.contatos.length === 0) {
        filtered.contatos.push(newContato);
      } else {
        filtered.contatos.forEach((contato, index) => {
          contato.id = contato.id ?? index + 1;
          contato.cargoId = contato.cargoContato?.id ? contato.cargoContato?.id : null;
          contato.cargo = contato.cargoContato?.nome || "";
          contato.index = index + 1;
        });
      }
      if (filtered.endereco) {
        var address = {
          rua: filtered.endereco.rua ?? "",
          bairro: filtered.endereco.bairro ?? "",
          cep: filtered.endereco.cep ?? "",
          numero: filtered.endereco.numero ?? "",
          complemento: filtered.endereco.complemento ?? "",
          cidade: filtered.endereco.cidade ? filtered.endereco.cidade.nome : "",
          uf: filtered.endereco.cidade && filtered.endereco.cidade.estado ? filtered.endereco.cidade.estado.nome : "",
        };

        filtered = {
          ...filtered,
          ...address,
          email: filtered.email ?? "",
          classificacaoFiscal: filtered.classificacaoFiscal ?? "",
          telefone: filtered.telefone ?? "",
          celular: filtered.celular ?? "",
          trilhaId: filtered.trilhaId ?? "",
          grupoSegmentoId: filtered.grupoSegmentoId ?? "",
          grupoSegmento: filtered.grupoSegmento ?? "",
          segmentoId: filtered.segmentoId ?? "",
          segmento: filtered.segmento ?? "",
          grupoCentralizadorId: filtered.grupoCentralizadorId ?? "",
          grupoCentralizador: filtered.grupoCentralizador ?? "",
          grupoCentralizadorConstrutoraId: filtered.grupoCentralizadorConstrutoraId ?? null,
          diasAntecipacao: filtered.diasAntecipacao ?? "",
          codigoSAP: filtered.codigo ?? "",
          codigoVendedor: filtered?.usuario?.codigo,
          recebimento: (filtered?.formaRecebimentoNFE ?? "").toLowerCase().replace(/-/g, ""),
          suframa: filtered.suframa ? true : false,
          dataNascimento: mask().formatDate(filtered.dataNascimento ?? ""),
          escritorioVendaId: filtered.escritorioVendaId ?? "",
          equipeVendaId: filtered.equipeVendaId ?? "",
          nomeObra: filtered.nomeObra ?? ""
        };
      }

      if (!opt.id || opt.id == 0 || !filtered) {
        console.error("Cliente não encontrado: " + opt.id, filtered);
        return;
      }

      setinitialValues(filtered);
    }
  }

  const handleSubmit = async (values) => {

    setFormValues({
      ...values,
      nomeObra: normalizeNomeObra(values.nomeObra, exibirNomeObra),
      atualizacao: new Date().toDateString(),
    });
  };

  const { formatNumber, cepMask, inscricaoMunicipalMask, cpfCnpj, dateMask } = mask();

  useEffect(() => {
    if (
      grupoSegmento &&
      grupoSegmento != 0 &&
      grupoSegmentoObjeto &&
      typeof grupoSegmentoObjeto == "object" &&
      Object.keys(grupoSegmentoObjeto)?.length > 0
    ) {
      const distribuidor = usuario?.slugAcessos.includes("acesso-ao-grupo-de-segmento-distribuidor");
      const exportador = usuario?.slugAcessos.includes("acesso-ao-grupo-de-segmento-exportador");
      const selectedGroupValues = grupoSegmentoObjeto[`id-${grupoSegmento}`];
      const codigo = selectedGroupValues?.codigo;

      if (
        selectedGroupValues &&
        codigo &&
        ((!distribuidor && ["400", "486"].includes(codigo)) || (!exportador && ["411"].includes(codigo)))
      ) {
        setSegmentoDistribuidorDisponivel(false);
      } else {
        setSegmentoDistribuidorDisponivel(true);
      }
    }
  }, [usuario?.slugAcessos, grupoSegmento]);

  useEffect(() => {
    if (Object.keys(initialValues).length > 0 && initialValues.id != 0) {
      const formatDate = (date) => new Date(date).toLocaleDateString("pt-BR");
      formikRef.current.setFieldValue( "duplaCategoriaVigencia", initialValues.validadeDe && initialValues.validadeAte
          ? `${formatDate(initialValues.validadeDe)} - ${formatDate(initialValues.validadeAte)}`
          : ""
      );

      formikRef.current.setFieldValue("duplaCategoriaElegivel", initialValues.duplaCategoria ? "Sim" : "Não");
      formikRef.current.setFieldValue("duplaCategoriaCondicao", initialValues?.condicao || "");
      formikRef.current.setFieldValue("descargaCliente", initialValues?.descargaCliente);
      formikRef.current.setFieldValue("descargaFumaca", initialValues?.descargaFumaca);
      SetSelectTrilha(initialValues?.trilhaId);
      SetSelectGrupoCentralizador(initialValues?.grupoCentralizadorId);
      SetSelectCargo(initialValues?.contatos);
      const optionRecebimento = (recebimentoOptions || []).find((opt) => opt.value === initialValues?.recebimento);
      if (optionRecebimento) {
        onChangeRecebimento(optionRecebimento);
      }

      SetSelectSegmento(initialValues?.segmentoId);
      SetSelectGrupoSegmento(initialValues?.grupoSegmentoId);

      setGrupoSegmentosInitialized(initialValues?.grupoSegmentoId);
    }

    if (initialValues.contatos.length === 1) {
      const contato = initialValues.contatos[0];

      const naoModificado =
        contato.cargoId === null &&
        contato.celular === "" &&
        contato.email === "" &&
        contato.fonte === "" &&
        contato.nome === "" &&
        contato.sobrenome === "" &&
        contato.telefone === "";

      if (naoModificado) {
        setinitialValues((prevValues) => ({
          ...prevValues,
          contatos: [
            {
              cargo: "",
              cargoId: null,
              celular: initialValues?.celular || "",
              email: initialValues?.email || "",
              fonte: "",
              id: 1,
              nome: initialValues?.nome || "",
              sobrenome: "",
              telefone: initialValues?.telefone || "",
            },
          ],
        }));
      }
    }
  }, [initialValues]);

  useEffect(() => {
    if (!formikRef.current) return;

    if (!isTrilhaPermitida) {
      if (formikRef.current.values?.grupoCentralizadorConstrutoraId) {
        onChangeGrupoCentralizadorConstrutora(null);
      }
      return;
    }

    if (!grupoCentralizadorConstrutoraOptions?.length) return;

    const currentId = formikRef.current.values?.grupoCentralizadorConstrutoraId;
    if (currentId === null || currentId === undefined || currentId === "") return;

    const currentOption = grupoCentralizadorConstrutoraOptions.find(
      (opt) => String(opt.value) === String(currentId)
    );
    if (!currentOption) return;

    onChangeGrupoCentralizadorConstrutora(currentOption);
  }, [isTrilhaPermitida, grupoCentralizadorConstrutoraOptions, trilha]);

  const onSuccess = () => {
    setLoading(false);
    navigate(`${initialPath}/carteira/solicitacoes`);
  };

  const onError = () => {
    setLoading(false);
  };

  const recebedorSalvar = useSalvarRecebedor(formValues, onSuccess, onError);
  const emissorSalvar = useSalvarEmissor(formValues, onSuccess, onError);

  useEffect(() => {
    if (Object.keys(formValues).length > 0) {
      setLoading(true);

      const salvar = recebedorEmissor ? emissorSalvar : recebedorSalvar;

      salvar();
    }
  }, [formValues]);

  useEffect(() => {
    onChangeTrilha({ value: 2 });
  }, []);

  useEffect(() => {
    if (cliente && Object.entries(cliente).length > 0) {
      fetchListagemRecebedores(cliente);
    }
  }, [cliente]);

  if (initialValues.id == 0) {
    <p>...Carregamento</p>;
  }

  const formStyle = {
    display: initialValues.id == 0 ? "none" : "block",
  };

  const [removeBlock, setremoveBlock] = useState({
    arrayContatos: [],
    index: null,
  });
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [indexBlock, setIndexBlock] = useState(null);

  function RemoveBlock() {
    removeBlock.arrayContatos[0].remove(removeBlock.index);
    setIsConfirmationOpen(false);
  }
  function HandleRemoveBlock(arrayContatos, index) {
    setIsConfirmationOpen(true);
    setIndexBlock(index);

    setremoveBlock((prevState) => ({
      // Mantenha os valores antigos do estado
      ...prevState,
      // Atualize o arrayContatos adicionando um novoContato
      arrayContatos: [...prevState.arrayContatos, arrayContatos],
      index: index,
    }));
  }

  function HandleRemoveBlockClosed() {
    setIsConfirmationOpen(false);
  }

  const [errorsContatos, setErrorsContatos] = useState();

  useEffect(() => {
    if (errorsContatos) {
      if (errorsContatos.contatos) {
        setExibirTodosContatos(true);
      }
    }
  }, [errorsContatos?.contatos]);
    const toast = useToast();
    const deleteContato = (index) => {


    if (Array.isArray(initialValues.contatos)) {
      initialValues.contatos = initialValues.contatos.filter(
        (_, i) => i !== index
      );
    }

    setinitialValues({
      ...initialValues,
      contatos: initialValues.contatos
    });

     toast({
        title: `Contato deletado com sucesso!`,
        description: "",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right"
      });
    initialValues.contatos.length <= 1 ? closeModalContatoSalvar() : null;
  };

  const editContato = (index) => {

    if (Array.isArray(initialValues.contatos)) {
      const contato = initialValues.contatos[index];

      setSelectedContact(contato);
      closeModalContatoSalvar();
      openModal();
    }
  };

  const esconderCampos = !initialValues?.duplaCategoria ? "!hidden" : "!flex";
  const [declaracaoEnviada, setDeclaracaoEnviada] = useState(false);

  useEffect(() => {
    const verificarDeclaracao = async () => {
      if (!initialValues?.id) return;

      const registro = await db.duplaCategoria.get(Number(initialValues.id));

      setDeclaracaoEnviada(!!registro);
    };

    verificarDeclaracao();
  }, [initialValues?.id]);

  return (
    <>
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        if (isTrilhaIMO && isTrilhaPermitida && !values.grupoCentralizadorConstrutoraId) {
          actions.setFieldError(
            "grupoCentralizadorConstrutoraId",
            "Grupo Centralizador Construtoras e obrigatorio"
          );
          return;
        }

        handleSubmit(values);
      }}
    >
      {({ errors, touched, setFieldValue, setFieldTouched, values, isSubmitting }) => {

        const primeiroContatoCliente = values.contatos?.[0];

        const declaracaoModalData = {
          nome: `${primeiroContatoCliente?.nome ?? ""} ${primeiroContatoCliente?.sobrenome ?? ""}`.trim(),
          email: primeiroContatoCliente?.email ?? "",
          telefone: primeiroContatoCliente?.telefone ?? primeiroContatoCliente?.celular ?? "",
        };

        const hasTipoPessoa = values.tipoN === 2 || values.tipoN === 1;
        const hasCodigoProspect = Boolean(values.codigoProspect);
        const dadosCadastraisGridClass =
          hasTipoPessoa && hasCodigoProspect
            ? "grid gap-x-4 md:grid-cols-1 lg:grid-cols-2"
            : hasTipoPessoa || hasCodigoProspect
            ? "grid gap-x-4 md:grid-cols-1 lg:grid-cols-3"
            : "grid gap-x-4 md:grid-cols-1 lg:grid-cols-2";

        useEffect(() => {
          if (abrirModalDeclaracao) {
            const contato = values.contatos?.[0];

            setFieldValue("emailContato", contato?.email ?? "");
            setFieldValue("nomeContato", `${contato?.nome ?? ""} ${contato?.sobrenome ?? ""}`.trim());
            setFieldValue("telContato", contato?.telefone ?? contato?.celular ?? "");
          }
        }, [abrirModalDeclaracao]);

        return (
          <>
          <Form className="mt-[-4rem] relative" id={`recebedor`} style={formStyle}>
            <div className={loading ? "relative spinner__form-active" : "relative"}>
              <ContainerForm title="Dados Cadastrais" isDisabled={true}>
                <div className={dadosCadastraisGridClass}>
                  <InputField
                    labelName="Código SAP:"
                    inputName="codigoSAP"
                    inputMask="offmask"
                    inputType="text"
                    isDisabled={true}
                  />
                  {hasCodigoProspect && (
                    <InputField
                      labelName="Código Prospect"
                      tooltip="Código antigo convertido em cliente SAP"
                      inputName="codigoProspect"
                      inputMask="offmask"
                      inputType="text"
                      isDisabled={true}
                    />
                  )}
                  <InputField
                    labelName="Código Vendedor:"
                    inputName="codigoVendedor"
                    inputMask="offmask"
                    inputType="text"
                    isDisabled={true}
                  />

                  {hasTipoPessoa ? (
                    <InputField
                      labelName="Tipo Pessoa:"
                      inputName="tipo"
                      inputMask="offmask"
                      inputType="text"
                      isDisabled={true}
                    />
                  ) : null}
                </div>

                {values.tipoN === 2 || values.tipoN === 1 ? (
                  <>
                    <div className="grid gap-x-4 md:grid-cols-1 lg:grid-cols-3">
                      <InputField
                        labelName="CNPJ/CPF:"
                        inputName="documento"
                        as={MaskedInput}
                        mask={cpfCnpj}
                        inputMask="onmask"
                        inputType="text"
                        forceUppercase
                        isDisabled={true}
                      />
                      <InputField
                        labelName="Inscrição Municipal:"
                        inputName="inscricaoMunicipal"
                        as={MaskedInput}
                        mask={inscricaoMunicipalMask}
                        guide={false}
                        inputMask="onmask"
                        keepCharPositions={true}
                        inputType="text"
                        inputMode="numeric"
                        isDisabled={true}
                      />
                      <InputField
                        labelName="Inscrição Estadual:"
                        inputName="inscricaoEstadual"
                        inputMask="offmask"
                        inputType="text"
                        isDisabled={true}
                      />
                    </div>
                    <div
                      className={`grid gap-x-4 md:grid-cols-1 ${
                        values.tipoN === 1 ? "lg:grid-cols-3" : "lg:grid-cols-2"
                      }`}
                    >
                      <InputField
                        labelName="Nome Fantasia:"
                        inputName="nomeFantasia"
                        inputMask="offmask"
                        inputType="text"
                        isDisabled={true}
                      />

                      {values.tipoN === 1 ? (
                        <InputField
                          labelName="Data de Nascimento:"
                          inputName="dataNascimento"
                          as={MaskedInput}
                          mask={dateMask}
                          inputMask="onmask"
                          inputType="text"
                          isDisabled={true}
                        />
                      ) : null}

                      <InputField
                        labelName="Razão Social:"
                        inputName="razaoSocial"
                        inputMask="offmask"
                        inputType="text"
                        isDisabled={true}
                      />
                    </div>
                  </>
                ) : null}

                <AddressForm formikRef={formikRef} disabled={true} />
                {exibirNomeObra && (
                  <InputField labelName="Nome da Obra:" inputName="nomeObra" inputMask="offmask" inputType="text" />
                )}
              </ContainerForm>


           <FieldArray
                name="contatos"
                render={(arrayContatos) => {
                  ArrayContatoRef.current = arrayContatos;
                  const contatosToDisplay = exibirTodosContatos ? values.contatos : [values.contatos[0]];
                  return (
                    <div className="container relative">
                      <ContainerForm title="Dados Pessoais">
                        {
                          contatosToDisplay.map((data, index) => (
                            <>
                              <div
                                className={`relative rounded-lg grid gap-x-4 md:grid-cols-1 lg:grid-cols-2 ${
                                  index % 2 != 0 ? " bg-[#DAE8F9] p-3" : ""
                                } ${contatosToDisplay.length > 1 ? " pt-12 " : ""}`}
                                key={index}
                              >
                                {contatosToDisplay.length > 1 && exibirTodosContatos && (
                                  <button
                                    type="button"
                                    className="scale-75 absolute top-0 right-0"
                                    onClick={() => HandleRemoveBlock(arrayContatos, index)}
                                  >
                                    <DeleteEdit />
                                  </button>
                                )}
                                <InputField
                                  labelName="Nome Contato:"
                                  inputName={`contatos[${index}].nome`}
                                  inputMask="offmask"
                                  inputType="text"
                                  hasImage={true}
                                  setFieldValue={setFieldValue}
                                  defaultValue={data && data.nome}
                                  isRequired
                                  difference={true}
                                />
                                <InputField
                                  labelName="Sobrenome Contato:"
                                  inputName={`contatos[${index}].sobrenome`}
                                  inputMask="offmask"
                                  inputType="text"
                                  hasImage={true}
                                  setFieldValue={setFieldValue}
                                  defaultValue={data && data.sobrenome}
                                  isRequired
                                  difference={true}
                                />

                                <Select
                                  name={`contatos[${index}].cargoId`}
                                  label="Cargo:"
                                  placeholder=""
                                  options={optionsCargo}
                                  value={
                                    data.cargoId
                                      ? { label: `${data.cargo || ""}`, value: data.cargoId }
                                      : cargoSelect.value(index) || null
                                  }
                                  onChange={(e) => {
                                    handleCargoChange(index, setFieldValue, setFieldTouched)(e);
                                    setFieldValue(`contatos[${index}].cargo`, e.label);
                                  }}
                                  errors={errors.contatos && errors?.contatos[index]?.cargoId}
                                  touched={touched?.contatos?.[index]?.cargoId}
                                  isRequired
                                />
                                <InputField
                                  labelName="Email do Contato:"
                                  inputName={`contatos[${index}].email`}
                                  inputMask="offmask"
                                  inputType="text"
                                  hasImage={true}
                                  setFieldValue={setFieldValue}
                                  defaultValue={data && data.email}
                                  isRequired
                                  difference={true}
                                />
                                <InputField
                                  labelName="Telefone de contato 1:"
                                  inputName={`contatos[${index}].telefone`}
                                  as={MaskedInput}
                                  mask={formatNumber}
                                  inputMask="onmask"
                                  inputType="text"
                                  hasImage={true}
                                  setFieldValue={setFieldValue}
                                  defaultValue={data && data.telefone}
                                  isRequired
                                  difference={true}
                                />
                                <InputField
                                  labelName="Telefone de contato 2:"
                                  inputName={`contatos[${index}].celular`}
                                  as={MaskedInput}
                                  mask={formatNumber}
                                  inputMask="onmask"
                                  inputType="text"
                                  hasImage={true}
                                  setFieldValue={setFieldValue}
                                  defaultValue={data && data.celular}
                                  difference={true}
                                />
                              </div>
                              <div className="flex items-center">
                                {((contatosToDisplay.length > 1 && index == contatosToDisplay.length - 1) ||
                                  contatosToDisplay.length == 1) && (
                                  <>
                                    <button
                                      type="button"
                                      className="mt-4 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search "
                                      onClick={() => {
                                        setExibirTodosContatos(true);
                                        arrayContatos.push(newContato);
                                      }}
                                    >
                                      Adicionar um novo contato
                                    </button>
                                    {values.contatos.length > 1 && (
                                      <>
                                        <button
                                          type="button"
                                          className="ml-2 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search mt-5 mr-2"
                                          onClick={() => setExibirTodosContatos(!exibirTodosContatos)}
                                        >
                                          {exibirTodosContatos ? "Recolher" : "Ver Mais"}
                                        </button>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </>
                          ))}
                      </ContainerForm>
                    </div>
                  );
                }}
              ></FieldArray>

              <ContainerForm title="Informações Adicionais">
                <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-3">
                  <Box color={"#C6C6C6"}>
                    <Select
                      name="trilhaId"
                      label="Trilha Global: "
                      placeholder="Trilha Global:"
                      options={optionsTrilha}
                      noOptionsMessage="Trilha não encontrado"
                      errors={errors.trilhaId}
                      touched={touched.trilhaId}
                      onChange={onChangeTrilha}
                      isRequired
                      isDisabled={true}
                      {...trilhaSelect}
                    />
                  </Box>

                  <Select
                    name="grupoSegmentoId"
                    label="Grupo Segmento:"
                    placeholder="Grupo Segmento:"
                    options={optionsGrupoSegmento}
                    noOptionsMessage="Grupo não encontrado"
                    errors={errors.grupoSegmentoId}
                    touched={touched.grupoSegmentoId}
                    onChange={onChangeGrupoSegmento}
                    isDisabled={!values.trilhaId || !segmentoDistribuidorDisponivel}
                    {...grupoSegmentoSelect}
                    isRequired
                  />
                  <Select
                    name="segmentoId"
                    label="Segmento:"
                    placeholder="Segmento:"
                    options={optionsSegmento}
                    noOptionsMessage="Grupo não encontrado"
                    errors={errors.segmentoId}
                    touched={touched.segmentoId}
                    onChange={onChangeSegmento}
                    isDisabled={!values.grupoSegmentoId || !segmentoDistribuidorDisponivel}
                    {...segmentoSelect}
                    isRequired
                  />
                  <Select
                    name="grupoCentralizadorId"
                    label="Grupo Centralizador:"
                    placeholder="Grupo Centralizador:"
                    options={setEmptyToSelectsOptions(
                      optionGruposCentralizadores,
                      defaultEmptyMessages.grupoCentralizador
                    )}
                    noOptionsMessage="Grupo não encontrado"
                    labelTooltip={
                      isTrilhaPermitida && (
                        <Info
                          bg="blue"
                          position="mobile-left"
                          text={
                            <>
                              Atualização do campo será feita após validação do <strong>GRUPO CENTRALIZADOR CONSTRUTORAS</strong>
                            </>
                          }
                          tooltipClass="w-4 h-4 relative mt-1"
                        />
                      )
                    }
                    errors={errors.grupoCentralizadorId}
                    touched={touched.grupoCentralizadorId}
                    onChange={onChangeGrupoCentralizador}
                    isDisabled={true}
                    {...grupoCentralizadorSelect}
                  />
                  <Select
                    name="recebimento"
                    label="Forma de Recebimento NFe:"
                    placeholder="Forma de Recebimento NFe:"
                    options={recebimentoOptions}
                    noOptionsMessage="Forma de Recebimento NFe não encontrada"
                    isRequired
                    onChange={(e) => {
                      onChangeRecebimento(e);
                    }}
                    errors={errors.recebimento}
                    touched={touched.recebimento}
                    {...recebimentoSelect}
                  />

                    <Select
                    name="equipeVendaId"
                    label="Equipe de venda:"
                    placeholder="Equipe de venda:"
                    options={optionsEquipe}
                    noOptionsMessage="Equipe de venda não encontrada"
                    onChange={(e) => {
                      onChangeEquipe(e);
                    }}
                    errors={errors.equipeVendaId}
                    touched={touched.equipeVendaId}
                    {...equipeSelect}
                    isRequired
                  />

                  <Select
                    name="escritorioVendaId"
                    label="Escritório de Venda:"
                    placeholder="Escritório de Venda:"
                    options={optionsEscritorio}
                    noOptionsMessage="Escritório de Venda não encontrado"
                    onChange={(e) => {
                      onChangeEscritorio(e);
                    }}
                    errors={errors.escritorioVendaId}
                    touched={touched.escritorioVendaId}
                    {...escritorioSelect}
                    isRequired
                  />

                {isTrilhaPermitida && (
                  <Select
                    name="grupoCentralizadorConstrutoraId"
                    label="Grupo Centralizador Construtoras:"
                    placeholder="Grupo Centralizador Construtoras:"
                                options={
                                  grupoOptionsLoaded
                                    ? grupoOptionsState
                                    : selectedGrupoOption
                                    ? [selectedGrupoOption]
                                    : []
                                }
                    noOptionsMessage="Grupo Centralizador Construtoras não encontrado"
                    onChange={onChangeGrupoCentralizadorConstrutora}
                    errors={errors.grupoCentralizadorConstrutoraId}
                    touched={touched.grupoCentralizadorConstrutoraId}
                                isRequired={isTrilhaIMO}
                                loading={grupoLoading}
                                isDisabled={grupoLoading || !values.trilhaId}
                                {...grupoCentralizadorConstrutoraSelect}
                  />
                )}

                {isTrilhaIMO && imoLinkCadastroGrupo && (
                  <button
                    type="button"
                    className="h-[50px] mt-8 lg:mt-[41.6px] px-4 bg-primaria text-white rounded-lg font-bold text-sm"
                    onClick={() => window.open(imoLinkCadastroGrupo, "_blank")}
                  >
                    Cadastrar Novo Grupo
                  </button>
                )}

                </div>
                 <div className="grid  gap-x-4 md:grid-cols-6 lg:grid-cols-12 mt-4">
                  <div className="col-span-4">
                    <label className="flex items-center space-x-2">
                      <Field
                        type="checkbox"
                        name="descargaCliente"
                        className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                      />
                      <span className="text-gray-700">Descarga no Cliente</span>
                    </label>
                  </div>
                </div>

                    <div className="mt-8">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-2 gap-y-1 items-start">
                        <h3 className="text-primaria text-2xl font-bold">Dupla Categoria</h3>
                        <Info
                          bg="blue"
                          text="Cliente com CNAEs de mais de uma classificação fiscal (Revenda, Consumidor Industrial ou Final)"
                        />
                      </div>
                      <div className="flex justify-between md:items-end items-start md:flex-row flex-col">
                        <div className="grid sm:grid-cols-7 grid-cols-2 gap-4 xl:w-1/2 lg:w-[65%] mt-4">
                          <InputField
                            customClasses="!font-semibold !uppercase !flex !justify-center !items-center"
                            labelName="Elegível"
                            inputName={`duplaCategoriaElegivel`}
                            inputMask="onmask"
                            inputType="text"
                            setFieldValue={setFieldValue}
                            isDisabled={true}
                            difference={true}
                          />

                          {
                            initialValues.validadeDe && initialValues.validadeAte && (
                              <div className={`col-span-3 ${esconderCampos}`}>
                                <InputField
                                  customClasses={`!flex !justify-center !items-center`}
                                  labelName="Vigência da declaração"
                                  inputName={`duplaCategoriaVigencia`}
                                  inputType="text"
                                  setFieldValue={setFieldValue}
                                  isDisabled={true}
                                  difference={true}
                                />
                              </div>
                            )
                          }

                          <div className={`col-span-3 ${esconderCampos}`}>
                            <InputField
                              customClasses={`
                                              ${initialValues.condicao === "Dentro do prazo" ? "!bg-green-500"
                                              : initialValues.condicao === "Vencimento Próximo" ? "!bg-yellow-500"
                                              : initialValues.condicao === "Vencido" ? "!bg-red-500"
                                              : "!bg-gray-500"}
                                              !flex !justify-center !items-center  !text-white font-semibold`
                                            }
                              labelName="Status da declaração"
                              inputName={`duplaCategoriaCondicao`}
                              inputMask="onmask"
                              inputType="text"
                              setFieldValue={setFieldValue}
                              difference={true}
                              isDisabled={true}
                            />
                          </div>
                        </div>
                        {
                          initialValues.condicao !== "Dentro do prazo" && initialValues.duplaCategoria && (
                            <button
                              type="button"
                              onClick={() => declaracaoEnviada ? setModalEnviada(true) : setAbrirModalDeclaracao(true)}
                              className={` ${declaracaoEnviada ? "!bg-secundaria opacity-80" : "bg-primaria text-white opacity-100"} flex justify-between items-center gap-4 p-4 md:ml-4 md:mt-0 mt-2 rounded-lg font-bold button-search`}
                            >
                              {
                                !declaracaoEnviada ? (
                                  <>
                                    <span className="text-nowrap">Enviar Declaração</span>
                                    <ChevronRightIcon />
                                  </>
                                ) : (
                                  <>
                                    <span className="text-nowrap">Declaração enviada</span>
                                    <CheckIcon className="!w-[10px] !h-[10px]" />
                                  </>
                                )
                              }
                            </button>
                          )
                        }
                      </div>
                    </div>


                  {initialValues?.areasVendaAmpliada?.length > 0 && (
                    <div className="mt-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-2 gap-y-1 items-start">
                      <h3 className="text-primaria text-2xl font-bold">Áreas de Venda Expandidas</h3>
                      <Tooltip />
                    </div>

                      <div className="space-y-1 max-w-[308px] mt-4">
                        {initialValues.areasVendaAmpliada.map((area, index) => (
                          <div
                            key={index}
                            className=" bg-[#D9D9D9] text-[#0A1D5D] text-sm font-bold uppercase px-4 py-1 rounded"
                          >
                            {area.setorAtividade?.descricao} ({area.grupoCliente?.descricao})
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

              </ContainerForm>

              <ValidateFormModal errors={errors} isSubmiting={isSubmitting} onInvalid={expandirTodosContatos} />

              {showSuccessMessage ? (
                <div className="bg-secundaria relative mt-6 container">
                  <div className="success-message-receiver py-6 text-center">
                    <p className="text-primaria text-2xl font-bold flex justify-center gap-x-4">
                      <IconSuccess />
                      Atualizado com sucesso!
                    </p>
                  </div>
                  <button
                    className="bg-secundaria p-4 rounded-lg text-primaria font-bold text-1xl absolute top-3 right-3 credit-button-solicitacao"
                    onClick={() => setShowSuccessMessage(false)}
                  >
                    Fechar
                  </button>
                </div>
              ) : /*(
              <div className="py-6 flex justify-end container">
                <button
                  type="submit"
                  className="flex  items-center gap-x-2 text-priamria bg-secundaria px-8 py-4 rounded-full font-bold credit-button-solicitacao"
                >
                  Salvar dados
                  <InfoArrow fill="#1C2B58" />
                </button>
              </div>
            )*/ null}
            </div>

            <ExcluirModal
              isOpen={isConfirmationOpen}
              onClose={HandleRemoveBlockClosed}
              onConfirm={RemoveBlock}
              onCancel={HandleRemoveBlockClosed}
              mensagem={`Tem certeza de que deseja excluir o bloco ${indexBlock}`}
            />
          </Form>

           <ModalContato  formModalValuesCreate={formModalValuesCreate} setFormModalValuesCreate={setFormModalValuesCreate} isOpen={isModalOpen} onClose={closeModal} openModalContatoSalvar={openModalContatoSalvar} optionsCargo={optionsCargo} emissorData={initialValues}  setinitialValues={setinitialValues} initialValues={initialValues} selectedContact={selectedContact}  setSelectedContact={setSelectedContact} />
           <ModalContatoSalvos formModalValuesCreate={formModalValuesCreate} setFormModalValuesCreate={setFormModalValuesCreate} formModalValues={formModalValues} setFormModalValues={setFormModalValues} optionsCargo={optionsCargo} deleteContato={deleteContato} isOpen={isModalContatoSalvar}  onClose={closeModalContatoSalvar}  initialValues={initialValues} setinitialValues={setinitialValues} setFieldValue={setFieldValue} />

           {abrirModalDeclaracao && (<ModalDeclaracao isOpen={abrirModalDeclaracao} onClose={() => setAbrirModalDeclaracao(false)} initialValues={initialValues} contatoEmail={declaracaoModalData.email} contatoNome={declaracaoModalData.nome} contatoTelefone={declaracaoModalData.telefone} setSuccessModal={setSuccessModal} setErrorModal={setErrorModal}/>)}
            <Modal
              isOpen={modalEnviada}
              onClose={() => setModalEnviada(false)}
              className="flex justify-center items-center flex-col"
              hideButtonOne={true}
              hideButtonTwo={true}
              title={
                <div className="flex items-center flex-col gap-y-4">
                  <div className="flex items-center justify-center rounded-full bg-secundaria p-3">
                    <CheckIcon className="!w-[40px] !h-[40px] !text-primaria" />
                  </div>
                  <p>Declaração já enviada!</p>
                </div>
              }
              sub={
                <div className="max-w-[350px]">
                  <p>Volte novamente em 5 dias para que possa solicitar uma nova declaração.</p>
                </div>
              }
            />

          <Modal
            isOpen={successModal}
            onClose={() => setSuccessModal(false)}
            className="flex justify-center items-center flex-col"
            hideButtonOne={true}
            hideButtonTwo={true}
            title={
              <div className="flex items-center flex-col gap-y-4">
                <div className="flex items-center justify-center rounded-full bg-secundaria p-3">
                  <CheckIcon className="!w-[40px] !h-[40px] !text-primaria" />
                </div>
                <p>Sua declaração foi enviada com sucesso!</p>
              </div>
            }
            sub={
              <div className="max-w-[350px]">
                <p>Em até 1 hora você receberá POR EMAIL um status sobre a solicitação.</p>
              </div>
            }
          />
          <Modal
            isOpen={errorModal}
            onClose={() => setErrorModal(false)}
            className="flex justify-center items-center flex-col"
            hideButtonOne={true}
            hideButtonTwo={true}
            title={
              <div className="flex items-center flex-col gap-y-4">
                <div className="flex items-center justify-center rounded-full bg-secundaria p-3">
                  <WarningIcon className="!w-[40px] !h-[40px] !text-primaria" />
                </div>
                <p>Houve um erro ao processar sua solicitação, por favor tente novamente</p>
              </div>
            }
          />

          <RegistrationJourneyModals
            clienteId={cliente?.id} 
            clienteCodigo="clientes" 
            tipo="recebedor" 
            temProposta={false}
            enabled={acessoJornadaFunil}
          />

          </>
        );
      }}
    </Formik>

    </>
  );
};

export default ReceiverFormEdit;
